import type { ColumnDef } from '@tanstack/react-table';
import { Table } from '@shared/components';
import { formatInvoiceMoney } from '../utils/formatInvoiceMoney';
import type { AgreementInvoiceLine } from '../types/agreements.types';

const columns: ColumnDef<AgreementInvoiceLine>[] = [
    { accessorKey: 'name', header: 'Line' },
    { accessorKey: 'kind', header: 'Kind' },
    { accessorKey: 'quantity', header: 'Quantity' },
    { accessorKey: 'net', header: 'Net', cell: (info) => formatInvoiceMoney(info.getValue<number | null>()) },
    { accessorKey: 'gross', header: 'Gross', cell: (info) => formatInvoiceMoney(info.getValue<number | null>()) },
];

const COLUMN_WIDTHS: Record<string, number> = { kind: 120, quantity: 110, net: 120, gross: 120 };

interface Props {
    id: string;
    lines: AgreementInvoiceLine[];
}

/** Fixed column widths keep Line, Kind, Quantity, Net and Gross aligned
 *  whichever invoice is expanded. */
export function SubmittedInvoiceLinesPanel({ id, lines }: Props) {
    return (
        <div id={id} className="border-t border-mp-border px-4 py-3">
            <Table<AgreementInvoiceLine>
                data={lines}
                columns={columns}
                enableSorting={false}
                columnWidths={COLUMN_WIDTHS}
                className="[&_table]:min-w-[40rem]"
                getRowId={(line) => line.id}
            />
        </div>
    );
}
